import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'services/hooks';

import './style.css';

function Spinner({ visible }) {
	if (visible)
		return (
			<div className="Spinner">
				<div className="dropshadow">
					<div className="loader"></div>
				</div>
			</div>
		);
	return null;
}

export function ChangesSpinner({ visible, failed, success, extraMessage }) {
	const [message, setMessage] = useState('');
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'spinner';

	const classes = classNames('spinner', {
		loading: !failed && !success,
		fail: failed,
		done: success,
	});

	useEffect(() => {
		if (extraMessage) {
			setMessage(extraMessage);
			return;
		}
		if (failed) {
			setMessage(getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_error_message`));
			return;
		}
		setMessage(getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_success_message`));
	}, [failed, success, extraMessage]);

	if (visible)
		return (
			<div className="ChangesSpinner">
				<div className={classes}></div>
				<div className="message">{message}</div>
			</div>
		);
	return null;
}

export default Spinner;
